
const digest = '4e10b13aedac4bc138ae5f40d074978ff73eeaf320eafaacf803e5389a875323';
const classes = {"wrapper":"_wrapper_19dh3_1","patient":"_patient_19dh3_9","patientImage":"_patientImage_19dh3_15","patientData":"_patientData_19dh3_20","title":"_title_19dh3_20","text":"_text_19dh3_26","content":"_content_19dh3_30","detailTitle":"_detailTitle_19dh3_39","medicament":"_medicament_19dh3_44","date":"_date_19dh3_58","prescriptBy":"_prescriptBy_19dh3_61","prescriptByItem":"_prescriptByItem_19dh3_67","name":"_name_19dh3_73","dose":"_dose_19dh3_76","controls":"_controls_19dh3_81","link":"_link_19dh3_93"};
const css = `._wrapper_19dh3_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._wrapper_19dh3_1 ._patient_19dh3_9 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  gap: 16px;
}
._wrapper_19dh3_1 ._patient_19dh3_9 ._patientImage_19dh3_15 {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
._wrapper_19dh3_1 ._patient_19dh3_9 ._patientData_19dh3_20 ._title_19dh3_20 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #000000;
}
._wrapper_19dh3_1 ._patient_19dh3_9 ._patientData_19dh3_20 ._text_19dh3_26 {
  color: #9ea0a5;
  font-size: 14px;
}
._wrapper_19dh3_1 ._content_19dh3_30 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 16px;
  color: #000000;
  padding: 24px;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._detailTitle_19dh3_39 {
  font-size: 14px;
  font-weight: 500;
  color: #1d65d8;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._medicament_19dh3_44 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._medicament_19dh3_44 ._title_19dh3_20 {
  font-weight: 500;
  min-width: 255px;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._medicament_19dh3_44 ._title_19dh3_20 span {
  font-weight: 400;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._medicament_19dh3_44 ._date_19dh3_58 {
  font-size: 14px;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._prescriptBy_19dh3_61 {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._prescriptBy_19dh3_61 ._prescriptByItem_19dh3_67 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._prescriptBy_19dh3_61 ._prescriptByItem_19dh3_67 ._name_19dh3_73 {
  color: #8b8b8b;
}
._wrapper_19dh3_1 ._content_19dh3_30 ._dose_19dh3_76 {
  display: flex;
  justify-content: center;
  min-width: 50px;
}
._wrapper_19dh3_1 ._controls_19dh3_81 {
  min-width: 220px;
  max-width: 280px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 12px 16px;
}
._wrapper_19dh3_1 ._controls_19dh3_81 ._link_19dh3_93 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  